const colors = [
  'rgba(100,149,237, 0.',
  'rgba(255,255,0, 0.',
  'rgba(255,0,0, 0.',
  'rgba(0,128,0, 0.',
  'rgba(165,42,42, 0.',
  'rgba(192,192,192, 0.',
];

export default colors;
